import { render, staticRenderFns } from "./ClusterDetails.vue?vue&type=template&id=61d6e958&scoped=true"
import script from "./ClusterDetails.vue?vue&type=script&lang=js"
export * from "./ClusterDetails.vue?vue&type=script&lang=js"
import style0 from "./ClusterDetails.vue?vue&type=style&index=0&id=61d6e958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6e958",
  null
  
)

export default component.exports